module.exports = __webpack_public_path__ + "img/thumbnail_PlainsZebra_m_albino.1df0b988.png";